import { staff, getStaff } from '../apis'
import supper from '../images/supper.jpg'

css .staff-page
	d:flex
	fld:column
	min-height:100vh

	.shape-header
		h:250px
	.staff
		flg: 1
		px:10%
		.person
			shadow: 0px 0px 20px rgba(0,0,0,.25)
			rd:lg
			d:flex
			my:2em
			min-height:400px

			fld@lt-lg:column
			min-height@lt-lg:unset

			.profile
				rdl:lg
				rdl@lt-lg:0
				rdt@lt-lg:lg
				d:flex
				bgr:no-repeat
				bgp:50%
				bgs:cover
				bgc:blue4
				flb:25%
				min-height: 200px
				# when stacked, give the cover photo more height so it isn't clipped
				min-height@lt-lg: 450px
			.info
				d:flex
				fld:column
				flb:75%
				p:1em 2em
				fs@xs:1em
				fs@sm:1.1em
				fs@md:1.25em
				fs@lg:1.50em
				fs@xl:1.75em
				.name
					ff:serif
					font-style:italic
					fs:1.5em
					c:rgba(0,0,0,.75)
				.title
					fw:bold
					fs:1.2em
					c:pink9/80%


tag staff-page

	def mount
		getStaff()

	<self.staff-page>
		<shape-header title="Staff" image=supper>
		<div.staff>
			for person in staff
				<div.person>
					<div.profile style="background-image:url({person.photoUrl})">
					<div.info>
						<div.name> person.name
						<div.title> person.title
						<div.bio> person.shortBio
		<footer-section>
